import avatar from "../assets/img/avatar.png";
import {Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ModalLoading from "../components/Formularios/Modal/ModalLoading";
import { getSessionData, removeSessionData } from "../utils/storageUtils";
import { Notificacoes } from "../components/Notificacoes";
import { PERFIL_PAINEL_TV } from "../types/PermissaoInterface";

const NavBar = () => {
  const navigate = useNavigate();
  const usuario = getSessionData("NomeUsuario") || "";
  const avatarClinica = getSessionData("DadosAvatarClinica") || "";
  const perfilTv = getSessionData("PerfilUsuario") === PERFIL_PAINEL_TV;

  useEffect(() => {
    if (usuario === "") {
      navigate("/login");
    }
  });

  const logoff = () => {
    removeSessionData("xc-helpdesk-token");
    removeSessionData("DadosUsuario");
    removeSessionData("EmailUsuario");
    removeSessionData("DadosUsuarioID");
    removeSessionData("PerfilUsuario");
    removeSessionData("isPerfilSuper");
    removeSessionData("NomeUsuario");
    navigate("/login");
  };

  const [avatarImg, setAvatarImg] = useState<string>(avatarClinica || "");
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <>
      <div className="navbar-custom">
        <ul className="list-unstyled topbar-menu float-end mb-0" style={{ display: 'flex', alignItems: 'center' }}>
          {!perfilTv && (
          <>
          {/* Componente de Notificações */}
          <li className="dropdown notification-list d-sm-inline-block" style={{ display: 'flex', alignItems: 'center', height: '70px', marginRight: '5px' }}>
            <Notificacoes />
          </li>
          
          <li className="dropdown notification-list" style={{ display: 'flex', alignItems: 'center' }}>
            <button
              type="button"
              className="nav-link dropdown-toggle nav-user arrow-none me-0"
              data-bs-toggle="dropdown"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <span className="account-user-avatar">
                <img
                  src={
                    avatarImg ? `data:image/png;base64,${avatarImg}` : avatar
                  }
                  alt="user"
                  className="rounded-circle"
                />
              </span>
              <span>
                <span className="account-user-name">{usuario}</span>
              </span>
            </button>
            <div className="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
              <button
                type="button"
                style={{ cursor: "pointer" }}
                className="dropdown-item notify-item"
                onClick={logoff}
              >
                <i className="mdi mdi-logout me-1"></i>
                <span>Logout</span>
              </button>
            </div>
          </li>
          </>
          )}
        </ul>
        <button className="button-menu-mobile open-left">
          <i className="mdi mdi-menu"></i>
        </button>
      </div>
      <ModalLoading show={loading} label="Carregando dados" />
    </>
  );
};
export { NavBar };
